/**
 * A (backbone) collection of plugin models.
 * @module app/models/PluginCollection
 */
import Backbone from "backbone";
import Plugin from "app/models/Plugin";
import _ from "underscore";
import urlService from "app/UrlService";
var PluginCollection = Backbone.Collection.extend({
  model: Plugin,
  url: function () {
    return urlService.apiurl("/application");
  },
  /**
   * Initializes this collection.
   * @param  {Array} models  Initial models for the collection.
   * @param  {object} options The options mapping.
   * @param {Context} options.context The context object for the collection.
   */
  initialize: function (models, options) {
    this.options = _.defaults({}, options);
  },
});

export default PluginCollection;



//////////////////
// WEBPACK FOOTER
// ./public/js/app/models/PluginCollection.js
// module id = 513
// module chunks = 1